// extracted by mini-css-extract-plugin
module.exports = {"file-dinh-kem":"textEditor_file-dinh-kem__RHCVv","skty":"textEditor_skty__3rtzQ","container":"textEditor_container__34H3L"};